<template>
  <v-card class="overflow-hidden bg-gray-l br-0" style="height: 100%">
    <header>
      <slot name="header">
        <top-bar :title="title" v-on:openDrawer="onOpenDrawer"></top-bar>
      </slot>
    </header>
    <nav>
      <slot name="nav">
        <nav-drawer :open="drawer" v-on:closeDrawer="onCloseDrawer"></nav-drawer>
      </slot>
    </nav>
    <main>
      <slot name="main">
        <div class="transaction-header">
          <div class="body-wrapper bg-black header-bg-img p-lr-20 p-b-15">
            <h1 class="desktop-view m-t-140 m-b-10">{{ title }}</h1>
            <v-row class="dashboard-header-wrapper input-header-wrapper transaction-filter-date">
              <div class="p-lr-15 w-100 p-b-5">
                  <span class="font-xs gray-text">Please note that all time stamps are using GMT -4.</span>
              </div>
              <div class="p-lr-15 th-search flex-container w-100 m-b-10">
                <v-text-field
                    v-model="formPayload.search"
                    @blur="filter"
                    solo
                    label="Search transaction"
                    prepend-inner-icon="fa-search"
                    clearable
                ></v-text-field>
                <v-btn rounded class="ipad-view header-btn gradient-yellow m-l-10 m-t-8 pull-right" @click="sheet = !sheet"><span class="m-r-5 font-xxs bold">Filter</span><i class="fas fa-chevron-right"></i></v-btn>
              </div>
            </v-row>
          </div>
        </div>
        <v-container class="br-wrapper bg-gray-l">
          <div class="body-wrapper p-b-70">
            <div class="transaction-body-wrapper">
              <div class="transaction-content">
                <div v-if="items.length">
                  <div v-for="(item, key) in items" :key="key" class="custom-card-shadow bg-white p-lr-10 p-t-5 p-b-5 m-b-10">
                    <v-row class="p-lr-5 p-t-10 p-b-10 gateway-wrapper">
                      <v-col cols="6">
                        <h4 class="font-md">{{ item.type }}</h4>
                      </v-col>
                      <v-col cols="6" class="gray-d-text right">
                        <p class="font-xs">{{ item.date }}</p>
                      </v-col>
                      <v-col cols="12" class="m-t-10">
                        <p class="font-nm">Transaction No. <span class="bold">{{ item.number }}</span></p>
                        <p class="font-nm m-t-5">Amount: <span class="bold">{{ item.amount }} {{ item.currency }}</span></p>
                      </v-col>
                      <v-col cols="12" class="m-t-10">
                        <div v-if="!item.isVoided" class="flex-inline-container m-r-5">
                          <v-chip class="chip-primary uppercase" v-if="item.status === 'Requested'">{{ item.status }}</v-chip>
                          <v-chip class="chip-primary uppercase" v-if="item.status === 'Acknowledged'">{{ item.status }}</v-chip>
                          <v-chip class="chip-success uppercase" v-if="item.status === 'Processed'">{{ item.status }}</v-chip>
                          <v-chip class="chip-error uppercase" v-if="item.status === 'Declined'">{{ item.status }}</v-chip>
                        </div>
                        <div v-else class="flex-inline-container m-r-5">
                          <v-chip class="chip-error uppercase">Voided</v-chip>
                        </div>
                        <v-chip class="chip-neteller m-r-5" v-if="item.paymentOptionType === 'NETELLER'">{{ item.paymentOptionType }}</v-chip>
                        <v-chip class="chip-skrill m-r-5" v-if="item.paymentOptionType === 'SKRILL'">{{ item.paymentOptionType }}</v-chip>
                        <v-chip class="chip-bitcoin m-r-5" v-if="item.paymentOptionType === 'BITCOIN'">{{ item.paymentOptionType }}</v-chip>
                      </v-col>
                    </v-row>
                  </div>
                </div>
                <div class="text-center no-record" v-else>
                  <div v-if="!loading">
                    <img :src="noResult" />
                    <p class="font-md bold black-text m-t-15">No record available</p>
                    <p class="gray-d-text m-t-5">We can't find any transaction at the moment.</p>
                  </div>
                </div>
              </div>
              <div class="desktop-view transaction-filter">
                <v-sheet class="custom-card-shadow bg-white">
                  <div class="p-15 gradient-blue m-b-15 white-text">
                    <h1 class="font-xl">Transaction Filter</h1>
                  </div>
                  <div class="p-lr-15 transaction-filter-date">
                    <div class="m-b-15">
                      <span class="gray-d-text font-nm">Select Date Covered</span>
                    </div>
                    <v-daterange v-model="range"></v-daterange>
                  </div>
                  <div class="p-r-15 p-b-15 p-l-15 font-xs bottom-sheet-container">
                    <div class="gray-d-text font-nm m-b-5">
                      Select Type
                    </div>
                    <v-chip-group
                      column
                      mandatory
                      active-class="chip-primary"
                      class="m-b-5"
                    >
                      <v-chip v-for="type in types" :key="type" class="ghost-btn">
                        {{ type }}
                      </v-chip>
                    </v-chip-group>

                    <div class="gray-d-text font-nm m-b-5">
                      Select Status
                    </div>
                    <v-chip-group
                      column
                      mandatory
                      active-class="chip-primary"
                      class="m-b-5"
                    >
                      <v-chip @click="formPayload.filter.status = []" class="ghost-btn">All Status</v-chip>
                      <v-chip v-for="(item, key) in status" :key="key" @click="formPayload.filter.status = [key]" class="ghost-btn">
                        {{ item }}
                      </v-chip>
                    </v-chip-group>

                    <div class="gray-d-text font-nm m-b-5">
                      Select Payment
                    </div>
                    <v-chip-group
                      column
                      mandatory
                      active-class="chip-primary"
                      class="m-b-5"
                    >
                      <v-chip @click="formPayload.filter.paymentOption = ''" class="ghost-btn">All Payment</v-chip>
                      <v-chip v-for="payment in payments" :key="payment" @click="formPayload.filter.paymentOption = payment" class="ghost-btn">
                        {{ payment }}
                      </v-chip>
                    </v-chip-group>
                    <div class="transaction-filter-cta m-t-15">
                      <v-btn class="gradient-green white-text v-btn-smb m-r-10" @click="filter" :loading="loading">Apply</v-btn>
                      <download-excel
                              type="csv"
                              :data="dataRow"
                              :name="dataFile"
                              :footer="dataFooter"
                              class="export-btn gradient-yellow v-btn-smb">
                        EXPORT
                      </download-excel>
                    </div>
                  </div>
                </v-sheet>
              </div>
            </div>
          </div>

          <v-dialog v-model="loading" hide-overlay persistent width="300">
            <v-card color="primary" dark>
              <v-card-text class="text-center p-t-10">
                Loading
                <v-progress-linear
                  indeterminate
                  color="white"
                  class="mb-0"
                ></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>

        </v-container>
      </slot>
    </main>
    
    <footer>
      <slot name="footer">
        <v-bottom-sheet v-model="sheet" inset>
          <v-sheet class="font-sm bg-white filter-ipad">
            <div class="p-lr-15 gradient-blue m-b-15 white-text">
            <v-row>
              <v-col cols="8">
                <h1 class="font-lg">Transaction Filter</h1>
              </v-col>
              <v-col cols="4" class="right">
                <span class="font-sm white-text underline" @click="sheet = !sheet">Dismiss</span>
              </v-col>
            </v-row>
          </div>
          <div class="p-lr-15 transaction-filter-date">
            <v-row>
              <v-col cols="12">
               <v-daterange v-model="range"></v-daterange>
              </v-col>
            </v-row>
          </div>
            <div class="p-r-15 p-b-15 p-l-15 font-xs bottom-sheet-container">
            <div class="gray-d-text">
              Select Type:
            </div>
            <v-chip-group
              column
              mandatory
              active-class="chip-primary"
            >
              <v-chip v-for="type in types" :key="type" class="ghost-btn">
                {{ type }}
              </v-chip>
            </v-chip-group>

            <div class="m-t-5 gray-d-text">
              Select Status:
            </div>
            <v-chip-group
              column
              mandatory
              active-class="chip-primary"
            >
              <v-chip @click="formPayload.filter.status = []" class="ghost-btn">All Status</v-chip>
              <v-chip v-for="(item, key) in status" :key="key" @click="formPayload.filter.status = [key]" class="ghost-btn">
                {{ item }}
              </v-chip>
            </v-chip-group>

            <div class="m-t-5 gray-d-text">
              Select Payment:
            </div>
            <v-chip-group
              column
              mandatory
              active-class="chip-primary"
            >
              <v-chip @click="formPayload.filter.paymentOption = ''" class="ghost-btn">All Payment</v-chip>
              <v-chip v-for="payment in payments" :key="payment" @click="formPayload.filter.paymentOption = payment" class="ghost-btn">
                {{ payment }}
              </v-chip>
            </v-chip-group>

            <div class="transaction-filter-cta m-t-15">
              <v-btn class="gradient-green white-text v-btn-smb m-r-10" @click="filter" :loading="loading">Apply</v-btn>
              <download-excel
                      type="csv"
                      :data="dataRow"
                      :name="dataFile"
                      :footer="dataFooter"
                      class="export-btn gradient-yellow v-btn-smb">
                EXPORT
              </download-excel>
            </div>
          </div>
          </v-sheet>
        </v-bottom-sheet>
      </slot>
    </footer>
  </v-card>
</template>

<script>
import NavDrawer from '@/components/shared/NavDrawer.vue'
import customFilters from '../utility/custom-filters'
import VDaterange from "../components/elements/date-picker/VDaterange";
import "vuetify-daterange-picker/dist/vuetify-daterange-picker.css";
import TopBar from "../components/shared/TopBar";
import JsonExcel from 'vue-json-excel'

export default {
  name: 'Internal',
  computed:{
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
  },
  components: { TopBar, VDaterange, NavDrawer, 'downloadExcel': JsonExcel },
  data () {
    return {
      title: 'Transaction History',
      noResult: require('@/assets/no-result.svg'),
      member: JSON.parse(localStorage.getItem('member')),
      items: '',
      loading: false,
      drawer: false,
      sheet: false,
      range: {},
      types: [
        'All Type',
        'Payout',
        'Withdrawal',
      ],
      status: [
        'Voided',
        'Requested',
        'Processed',
        'Declined',
        'Acknowledged',
      ],
      payments: [
        'Bitcoin',
        'Skrill',
        'Neteller',
      ],
      formPayload: {
        search: '',
        page: 1,
        filter: {
          fromDate: '',
          toDate: '',
          type: [2,12],
          status: [],
          paymentOption: '',
        }
      },
      dataFile: 'TransactionHistory_' + customFilters.moment(new Date(), 'DD-MM-YYYY') + '.csv',
      dataRow: [],
      dataFooter: [],
      isExported: false,
    }
  },
  methods: {
    list() {
      if (typeof this.range.start !== 'undefined' && this.range.start !== '') {
        this.formPayload.filter.fromDate = this.range.start
        this.formPayload.filter.toDate = this.range.end
      }

      if (this.formPayload.filter.status[0] === 0) {
        this.formPayload.filter.status = []
        this.formPayload.filter['isVoided'] = 1
      } else {
        this.formPayload.filter['isVoided'] = []
      }

      this.items = ''
      this.loading = true
      this.$store.dispatch('transactionHistory/list', this.formPayload).then((response) => {
        setTimeout(() => {
          const transactions = response.items
          const newJson = []
          let newJsonRow = []

          transactions.forEach((item) => {
            newJson.push({
              id: item.id,
              number: item.number,
              type: customFilters.capitalize(item.type),
              status: customFilters.capitalize(item.status),
              paymentOptionType: item.paymentOptionType,
              isVoided: item.isVoided,
              amount: item.amount,
              date: customFilters.moment(item.date, 'MMMM D, YYYY hh:mm:ss A'),
              currency: item.currency
            })

            newJsonRow.push({
              'Transaction No': item.number,
              'Payment Option': item.paymentOptionType,
              'Transaction Type': customFilters.capitalize(item.type),
              'Status': item.isVoided ? 'Voided' : customFilters.capitalize(item.status),
              'Amount': item.amount,
              'Currency': item.currency,
              'Date': customFilters.moment(item.date, 'MMMM D, YYYY hh:mm:ss A')
            })
          });

          this.items = newJson
          this.dataRow = newJsonRow
          this.loading = false
        }, 500)
      })
    },
    filter() {
       return this.list()
    },
    logout() {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push({ name: 'auth-login' })
      })
    },
    onOpenDrawer(value) {
      this.drawer = value
    },
    onCloseDrawer(value) {
      this.drawer = value
    },
    exported(event) {
      this.isExported = true
      setTimeout(() => {
        this.isExported = false
      }, 3 * 1000)
    }
  },
  mounted() {
    this.list()
  },
  filters: {
    moment(date) {
      return customFilters.moment(date, 'MMMM D, YYYY hh:mm:ss A')
    },
    capitalize(value) {
      return customFilters.capitalize(value)
    },
    decimal(value) {
      return customFilters.decimal(value, 2)
    }
  }
}
</script>

<style>
  .v-toolbar.v-toolbar--absolute {
    z-index: 100;
    box-shadow: none;
  }
  .v-navigation-drawer--absolute {
    z-index: 102 !important;  
  }
  .v-overlay--absolute {
    z-index: 101 !important;
  }
  .v-toolbar__content {
    height: 160px !important;
  }
  .v-app-bar--is-scrolled {
    transform: translateY(0px) !important;
  }
  .v-app-bar--hide-shadow.v-app-bar--is-scrolled {
    transform: translateY(-160px) !important;
  }
  .v-application .overflow-hidden {
    border-radius: 0;
  }
  .theme--light.v-sheet {
    background-color: #EFEFF4;
  }
  .transaction-filter-cta {
    display: flex;
    justify-content: flex-end;
  }
  .transaction-filter {
    display: none;
  }
  @media only screen and (min-width: 768px) {
    .transaction-header {
      position: relative;
    }
    .transaction-header .bg-black {
      background: #EFEFF4 !important;
    }
    .transaction-header .font-xs {
      font-size: 14px;
      margin-top: 10px;
      display: inline-block;
    }
    .transaction-header .p-b-15 {
      padding-bottom: 0;
    }
    .bottom-sheet-container {
      font-size: 14px;
    }
    .v-chip.v-size--default {
      font-size: 12px !important;
    }
    .font-md {
      font-size: 18px !important;
    }
    .font-xs {
      font-size: 12px;
    }
    .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
      -webkit-box-shadow: 0px 0px 15px 0px rgba(23,37,48,0.10);
      -moz-box-shadow: 0px 0px 15px 0px rgba(23,37,48,0.10);
      box-shadow: 0px 0px 15px 0px rgba(23,37,48,0.10);
    }
  }
  @media only screen and (min-width: 1024px) {
    .transaction-body-wrapper {
      display: flex;
    }
    .transaction-content {
      width: 65%;
      margin-right: 20px;
    }
    .transaction-filter {
      display: block;
      width: 35%;
      height: fit-content;
    }
    .th-search {
      width: 400px;
    }
  }
  @media only screen and (min-width: 1030px) {
    .transaction-content {
      width: 75%;
    }
    .transaction-filter {
      width: 25%;
    }
  }
</style>
